import { useCallback, useContext } from 'react'
import { CutterContext } from '../contexts/CutterContext'
import { formatMilliseconds } from '../../functions/formatMilliseconds'
import { getPositionMilliseconds } from '../functions/getPositionMilliseconds'

export function useFormatMilliseconds() {
  const { sampleRate } = useContext(CutterContext).audioBuffer

  return useCallback(
    (position: number) => formatMilliseconds(getPositionMilliseconds(position, sampleRate)),
    [sampleRate],
  )
}
